import moment from "moment";

Vue.component('files', {
    data () {
        return {
            loading: false,

            files: [],

            uploadForm: {
                file: null,
                name: ''
            },

            processing: false,

            search: '',

            selectedFiles: []
        };
    },

    mounted () {
        this.getFiles();
    },

    methods: {
        getFiles(e) {
            if (e != undefined) {
                e.preventDefault();
            }

            this.loading = true;

            axios.get('/api/files/', {
                params: {
                    search: this.search
                }
            }).then((response) => {
                this.files = response.data;
                this.loading = false;
            });
        },

        deleteFile (id) {
            this.activeId = id;

            $('#delete-file').modal('show');
        },

        doDeleteFile () {
            axios.post('/api/files/delete/' + this.activeId).then(response => {
                this.getFiles();

                $('#delete-file').modal('hide');
            });
        },

        uploadFile () {
            this.processing = true;

            axios.post('/api/files/upload', this.uploadForm, {
                headers: {
                    'Content-Type': undefined
                },
                transformRequest (data) {
                    var formData = new FormData();

                    formData.append('name', data.name);
                    formData.append('file', data.file);

                    return formData;
                }
            }).then((response) => {
                $('#upload-file').modal('hide');
                this.processing = false;
                this.getFiles();
            });
        },

        handleFileSelected (e) {
            this.uploadForm.file = e.target.files[0];

            if (this.uploadForm.name.length == 0) {
                let name = this.uploadForm.file.name.split('.');
                name.pop();

                this.uploadForm.name = name.join('.');
            }
        }
    },

    computed: {
        selectedFilesToString () {
            return JSON.stringify(this.selectedFiles);
        }
    },


    filters: {
        date (value) {
            return value != null ? moment(value).format("DD/MM/YYYY HH:mm") : value;
        }
    }
});